import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import axios from 'axios';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Authenticationservice } from '../../services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { finalize, reduce } from 'rxjs/operators';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { ExcelService } from 'src/app/services/excel.service';

@Component({
  selector: 'app-credit',
  templateUrl: './credit.component.html',
  styleUrls: ['./credit.component.css']
})
export class CreditComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;


  uploadPercentage$: Observable<number>;
  FormFirst: FormGroup;
  FormCredit: FormGroup;

  get form() { return this.FormFirst.controls; }
  get form2() { return this.FormCredit.controls; }

  constructor(private auth: Authenticationservice, private excelService: ExcelService, private spinner: NgxSpinnerService, private route: ActivatedRoute, private router: Router, private storage: AngularFireStorage) {
    let userdata: { zonedata?: any; supcode?: any; };
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.supcode = userdata.supcode;

    this.FormFirst = new FormGroup({
      idcard: new FormControl(),
      //date_add:new UntypedFormControl('',Validators.required),
      birthdaydate: new FormControl(),
      fullname: new FormControl('', Validators.required),
      birthday: new FormControl('', [Validators.required,
      Validators.pattern('[0-9/]{10}'),
      Validators.minLength(10)]),
      fmtel: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern("[0-9]{11}")]),
    })

    this.FormCredit = new UntypedFormGroup({
      fmcodeperson1: new FormControl('', Validators.required),
      fmnameperson1: new FormControl(),
      fmcodeperson2: new FormControl('', Validators.required),
      fmnameperson2: new FormControl(),
      fmcodeperson3: new FormControl('', Validators.required),
      fmnameperson3: new FormControl(),
      fmnameorcode: new FormControl('', Validators.required),

    })

    //this.goloadcheckpromiseall();     
    //this.spinner.hide();  
  }
  displayfarmaer: string[] = ['fmcode', 'fmname', 'zone', 'cane'];
  displayunckeck: string[] = ['action', 'count', 'fmcode', 'fmname', 'status', 'promise', 'dateupdate', 'checkpromise']; //'commendBRD'

  loadPS = [false, false, false, false];
  zone: string; supcode: any;
  year: string
  show_tel = false;
  ngOnInit(): void {
    var pathArray = window.location.pathname.split('/');
    this.year = this.route.snapshot.paramMap.get('year');
    console.log('this.year', this.year)

    console.log('pathArray', pathArray)
    setTimeout(() => {
      this.Loaddatacontact();
      //this.Loadtendata();
      this.goloadpromiseall();
    }, 200);
  }

  Filterby(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.allpromisebyzone.filter = filterValue.trim().toLowerCase();;
    if (this.allpromisebyzone.paginator) {
      this.allpromisebyzone.paginator.firstPage();
    }
  }

  // สัญญาทั้งหมด
  allpromisebyzone: any;
  datapromisebyzone: any;
  goloadpromiseall() {
    this.spinner.show();
    var url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_promisted" + this.year + "]&w=[SUPZONE]='" + this.zone + "'";//101
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      data.sort((a, b) => new Date(b.DateUpdate).getTime() - new Date(a.DateUpdate).getTime());
      data = data.map((item: any) => {
        return { ...item, print2: false };
      });
      this.datapromisebyzone = data
      this.tendata = data.slice(0, 15);
      this.chagetab(1);
      //console.log('tendata', this.tendata)
    }).catch(err => {
      console.log(err);
    })
  }
  // สัญญาในโซน
  //checkpromisebyzone=[]; 
  Farmerdata: MatTableDataSource<unknown>;
  ngAfterViewInit() {
    // this.Farmerdata.paginator = this.paginator;
    // this.Farmerdata.sort = this.sort;   
    //this.paginator.pageSize = 10;
  }

  tabcolor: string = "";
  addpromise: boolean;
  checkpromise: boolean;
  allpromise: boolean;
  id = 1;
  chagetab(id: number) {
    this.id = id;
    let data = this.datapromisebyzone;
    let data2 = [];
    let str = '';
    if (id == 1) {
      data2 = [];
    }
    else if (id == 2) {
      data2 = data.filter((el: { PromiseIN: string; }) => el.PromiseIN == '0');
      str = 'ยังไม่ตรวจสัญญา';
    }
    else if (id == 3) {
      data2 = data.filter((el: { PromiseIN: string; }) => el.PromiseIN == '1');
      str = 'ตรวจสัญญาแล้ว';
    }
    else if (id == 4) {
      data2 = data;
      str = 'ข้อมูลทั้งหมด';
    }
    console.log('str:', str, data2.length);
    if (data.length) {
      this.allpromisebyzone = new MatTableDataSource<any>(data2);
      this.paginator.length = this.allpromisebyzone.length;
      this.paginator.pageSize = 10;
      this.allpromisebyzone.sort = this.sort;
      this.allpromisebyzone.paginator = this.paginator;
    }
  }

  exportAsExcel(): void {
    let zone = this.zone;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/dataPromise?YearT=${this.year}&SUPZONE=${zone}`;
    this.spinner.show();
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = (res.data);
      this.excelService.exportAsExcelFile(data, `ข้อมูลสัญญา${this.year}_ในโซน_${zone}`);
    }).catch(error => {
      console.log(error);
    })
  };


  //Getalldata
  Selectfarmer = [];
  Loaddatacontact() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=trim(fmcode)[fmcode],trim(fmcode_b1)[fmcode_b1],trim(fmname)[fmname],SUPZONE,SUPCODE,area" + this.year + "[area],IDCARD,trim(TEL)[TEL],birthdayTH,groupCode&f=[CPS6263].[dbo].[t_farmer]&w=supzone='" + this.zone + "'order by [fmname]";
    axios.get(url).then(res => {
      let data = res.data;
      this.Selectfarmer = data;
      console.log('t_farmer:', this.zone, data)
    }).catch(error => {
      console.log(error);
    })
    // Add to first Form
    const now = new Date;
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var day = now.getDate();
    this.date_add = year + "-" + month + "-" + day;
  }


  fullname: string;
  cardid: string;
  fmcode: string;
  fmbirthday: string;
  date_add: string = null;
  Toformdata() {
    let name = this.FormFirst.get('fullname').value;
    let code: string = name.slice(1, 11);
    if (name == null || name == '') { }
    else {
      let data = this.Selectfarmer.filter(el => el.fmcode_b1 == code);
      console.log(data[0].fmname, data[0], ' | ', 'nameslice:', code);
      this.fullname = data[0].fmname;
      this.cardid = data[0].IDCARD;
      this.fmcode = data[0].fmcode;
      this.FormFirst.get('idcard').setValue(data[0].IDCARD);
      this.FormFirst.get('fullname').setValue(data[0].fmname);
      this.FormFirst.get('fmtel').setValue(data[0].TEL);
      if (data[0].birthdayTH == '01/01/1900' || data[0].birthdayTH == '1/1/1900') {
        this.fmbirthday = '01/01/2433';
        this.FormFirst.get('birthday').setValue('01/01/2433');
      }
      else {
        // this.fmbirthday = data[0].birthdayTH; 
        this.FormFirst.get('birthday').setValue(data[0].birthdayTH);
      }
      this.goCheckpromise(data[0].fmcode);
    }
  }

  // 10 ข้อมูลล่าสุดที่บันทึกคำประกัน
  tendata = [];
  // ตรวจสอบคนค้ำประกัน
  Selectfmcode() {
    let fmcode = this.FormFirst.get('fullname').value;
    console.log(fmcode);
  }

  person1 = []; person2 = []; person3 = [];

  t_n1 = ''; t_n2 = ''; t_n3 = '';

  CheckFarmer1() {
    let fmcode1 = this.FormCredit.get('fmcodeperson1').value;
    let fmcode2 = this.FormCredit.get('fmcodeperson2').value;
    let fmcode3 = this.FormCredit.get('fmcodeperson3').value;
    if (fmcode1 == fmcode2 || fmcode1 == fmcode3) { alert('ข้อมูลคนค้ำ ไม่สามารถซ้ำกันได้ กรุณาลองใหม่'); }
    else if (fmcode1 == this.fmcode) { alert('ไม่สามารถค้ำให้ตัวเองได้'); }
    else {
      this.loadPS[1] = true;
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_ckpromise" + this.year + "]&w=fmcode='" + fmcode1 + "'";
      axios.get(url)
        .then(res => {
          this.loadPS[1] = false;
          let data = res.data;
          if (data.length == 1) {
            this.person1 = data;
            this.t_n1 = data[0].CanGet3;
            console.log('person1:', data);
            this.FormCredit.get('fmnameperson1').setValue(this.person1[0].fmname);
            if (this.person1[0].nowPromise > 3) {
              alert("ไม่สามารถค้ำประกันได้");
            }
          }
          else {
            this.person1 = [];
            this.t_n1 = 'N';
            this.FormCredit.get('fmnameperson1').setValue('');
            alert("ไม่มีข้อมูลผู้ค้ำ");
          }
        }
        ).catch(error => {
          console.log(error);
        });
    }
  }

  CheckFarmer2() {
    let fmcode1 = this.FormCredit.get('fmcodeperson1').value;
    let fmcode2 = this.FormCredit.get('fmcodeperson2').value;
    let fmcode3 = this.FormCredit.get('fmcodeperson3').value;
    if (fmcode2 == fmcode1 || fmcode2 == fmcode3) { alert('ข้อมูลคนค้ำ ไม่สามารถซ้ำกันได้ กรุณาลองใหม่'); }
    else if (fmcode2 == this.fmcode) { alert('ไม่สามารถค้ำให้ตัวเองได้'); }
    else {
      this.loadPS[2] = true;
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_ckpromise" + this.year + "]&w=fmcode='" + fmcode2 + "'";
      axios.get(url)
        .then(res => {
          this.loadPS[2] = false;
          let data = res.data;
          if (data.length == 1) {
            this.person2 = data;
            this.t_n2 = data[0].CanGet3;
            console.log('person2:', data);
            this.FormCredit.get('fmnameperson2').setValue(this.person2[0].fmname);
            if (this.person1[0].nowPromise > 3) {
              alert("ไม่สามารถค้ำประกันได้");
            }
          }
          else {
            this.person2 = [];
            this.t_n2 = 'N';
            this.FormCredit.get('fmnameperson2').setValue('');
            alert("ไม่มีข้อมูลผู้ค้ำ");
          }
        }
        ).catch(error => {
          console.log(error);
        })
    }
  }

  CheckFarmer3() {
    let fmcode1 = this.FormCredit.get('fmcodeperson1').value;
    let fmcode2 = this.FormCredit.get('fmcodeperson2').value;
    let fmcode3 = this.FormCredit.get('fmcodeperson3').value;
    if (fmcode3 == fmcode1 || fmcode3 == fmcode2) { alert('ข้อมูลคนค้ำ ไม่สามารถซ้ำกันได้ กรุณาลองใหม่'); }
    else if (fmcode3 == this.fmcode) { alert('ไม่สามารถค้ำให้ตัวเองได้'); }
    else {
      this.loadPS[3] = true;
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_ckpromise" + this.year + "]&w=fmcode='" + fmcode3 + "'";
      axios.get(url)
        .then(res => {
          this.loadPS[3] = false;
          let data = res.data;
          if (data.length == 1) {
            this.person3 = data;
            this.t_n3 = data[0].CanGet3;
            console.log('person3:', data);
            this.FormCredit.get('fmnameperson3').setValue(this.person3[0].fmname);
            if (this.person1[0].nowPromise > 3) {
              alert("ไม่สามารถค้ำประกันได้");
            }
          }
          else {
            this.person3 = [];
            this.t_n3 = 'N';
            this.FormCredit.get('fmnameperson3').setValue('');
            alert("ไม่มีข้อมูลผู้ค้ำ");
          }
        }
        ).catch(error => {
          console.log(error);
        });
    }
  }

  forwardcheck: any;
  //ck_pm = 0
  ck_dpm: number;//การมีข้อมูล
  ck_pmIn: number;//การผ่านสัญญา
  ck_guarantor: number;
  goCheckpromise(fmid: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_ckpromise" + this.year + "]&w=fmcode='" + fmid + "'";
    axios.post(url)
      .then(res => {
        let data = res.data;
        //this.ck_pm=res.data.ck_pm;
        if (data.length == 0) { console.log(fmid, "ยังไม่ผ่านสัญญา"); }
        else if (data[0].PromiseIN == 1) {
          alert("มีสัญญาแล้ว");
          //this.forwardcheck = 1;
        }
        else if (data[0].PromiseIN == 0) {
          alert("มีสัญญาแล้วแต่ยังไม่ตรวจ");
          //this.forwardcheck = 1;
        }
        this.ck_pmIn = data[0].PromiseIN;
        this.ck_dpm = data[0].ck_pm;
        this.ck_guarantor = data[0].ck_guarantor;
        console.log('data[0]', data[0])
        console.log(fmid, "ยังไม่ผ่านสัญญา", this.ck_pmIn, ' มีสัญญา', this.ck_dpm);
      }).catch(error => console.log(error))
  }
  // บันทึกข้อมูล แบบใช้เหลักทรัพย์
  InsertCredit() {
    this.submitted = true;
    // stop here if form is invalid
    const now = new Date;
    let fmtel = this.FormFirst.get('fmtel').value;
    let birthday = this.FormFirst.get('birthday').value;
    let cardid = (<HTMLInputElement>document.getElementById("cardid")).value;
    var dateb = new Date(birthday);
    let birthdaydete = dateb.getDate() + "/" + (dateb.getMonth() + 1) + "/" + (dateb.getFullYear());
    if (birthday == '01/01/1900' || birthday == '1/1/1900') { birthdaydete = '01/01/2443'; }
    let fmcode = this.fmcode;
    let urlforinsert = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/insert_Promise_w?year=${this.year}&FMCODE='${fmcode}'`
      + `&FullName='${this.fullname}'&Birthday='${birthday}'&ID_No='${cardid}'&DateAdd='${this.date_add}'&tel='${fmtel}'`;
    let urlforupdate = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/update_Promise_w?year=${this.year}&FMCODE='${fmcode}'`
      + `&FullName='${this.fullname}'&Birthday='${birthday}'&ID_No='${cardid}'&DateAdd='${this.date_add}'&tel='${fmtel}'`;

    let url: string;
    let ck_dpm = this.ck_dpm;

    console.log('ck_pmIn', this.ck_pmIn, ' ck_dpm', ck_dpm);
    if (ck_dpm == 1) { url = urlforupdate; }
    else if (ck_dpm == 0) { url = urlforinsert; }

    /* if (ck_dpm == 1) {
       alert("มีข้อมูลอยู่แล้ว!");
     }//    +"'&DateAdd='"+this.date_add+
     */
    if (true) {
      if (fmcode == null || fmcode == undefined || fmcode.length == 0) { alert("กรุณาเลือกชาวไร่"); }
      else if (cardid == null || cardid == undefined || cardid == '') { alert("กรุณากรอกเลขบัตรประชาชน"); }
      else if (birthday == undefined || birthday == '') { alert("กรุณาระบุวันเกิด"); }
      else {
        console.log(url);
        if (confirm('ยืนยันบันทึกใช้หลักทรัพย์ ' + fmcode)) {
          axios.post(url).then(res => {
            console.log(res.data)
            if (res.data.rowsAffected[0] == 1) {
              alert("บันทึกข้อมูลแล้วค่ะ");
              this.FormFirst.reset();
              this.FormCredit.reset();
              //this.Loadtendata();
              //this.goloadcheckpromiseall(); 
              this.goloadpromiseall();
            }
            else if (res.data.code) { alert("บันทึกข้อมูลไม่สำเร็จเนื่องจากมีข้อมูลแล้ว"); }
          }).catch(error => console.log(error))
        }
      }
    }
  }

  // บันทึกแบบมีคนค้ำ 3 คน
  InsertCreditWithPerson() {
    this.submitted = true;
    console.log(this.FormCredit.value);
    let fmcode = (this.FormFirst.get('fullname').value).slice(1, 7);
    let birthday = this.FormFirst.get('birthday').value;
    let fmtel = this.FormFirst.get('fmtel').value;
    const now = new Date;
    let fmcode1 = this.person1[0].fmcode;
    let fmcode2 = this.person2[0].fmcode;
    let fmcode3 = this.person3[0].fmcode;
    let fmname1 = this.person1[0].fmname;
    let fmname2 = this.person2[0].fmname;
    let fmname3 = this.person3[0].fmname;
    let cardid = (<HTMLInputElement>document.getElementById("cardid")).value;
    //console.log('person1:', this.person1, ' person2:', this.person2, ' person3:', this.person3);

    var dateb = new Date(birthday);
    let birthdaydete = dateb.getDate() + "/" + (dateb.getMonth() + 1) + "/" + (dateb.getFullYear());
    if (birthday == undefined || birthday == '' || birthday == '01/01/1900' || birthday == '1/1/1900') { alert("กรุณาระบุวันเกิด"); }
    else if (birthday == '01/01/1900' || birthday == '1/1/1900') { birthdaydete = '01/01/2443'; }
    else if (this.person1[0].CanGet3 == "N" || this.person2[0].CanGet3 == "N" || this.person3[0].CanGet3 == "N") { alert("ไม่สามารถใช้คนค้ำนี้ได้"); }
    else if (this.fmcode == null || this.fmcode == undefined || this.fmcode == '') { alert("กรุณาเลือกชาวไร่"); }
    else if (cardid == null || cardid == undefined || cardid == '') { alert("กรุณากรอกเลขบัตรประชาชน"); }
    let url = ''; // ไว้เช็คว่าใช้ตัวไหน
    let urlforupdate = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/update_Promise_w?year=${this.year}&FMCODE='${this.fmcode}'&FullName='${this.fullname}'&Birthday='${birthday}'&ID_No='${cardid}'`
      + `&FmCode1='${fmcode1}'&FullName1='${fmname1}'&FmCode2='${fmcode2}'&FullName2='${fmname2}'&FmCode3='${fmcode3}'&FullName3='${fmname3}'&DateAdd='${this.date_add}'&tel='${fmtel}'`;

    let urlforinsert = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/insert_Promise_w?year=${this.year}&FMCODE='${this.fmcode}'&FullName='${this.fullname}'&Birthday='${birthday}'&ID_No='${cardid}'`
      + `&FmCode1='${fmcode1}'&FullName1='${fmname1}'&FmCode2='${fmcode2}'&FullName2='${fmname2}'&FmCode3='${fmcode3}'&FullName3='${fmname3}'&DateAdd='${this.date_add}'&tel='${fmtel}'`;

   /* 
   if (this.forwardcheck == 1)    { url = urlupdate; }
    else if (this.forwardcheck != 1){ url = urlforfulldata; }
*/  console.log('ck_pmIn', this.ck_pmIn, ' ck_dpm', this.ck_dpm);
    if (this.ck_dpm == 1) { url = urlforupdate; }
    else if (this.ck_dpm == 0) { url = urlforinsert; }

    console.log(url);
    if (this.ck_pmIn == 1 && this.ck_guarantor == 1 && this.ck_dpm == 1) {
      alert("มีข้อมูลอยู่แล้ว!");
    }//    +"'&DateAdd='"+this.date_add+    
    else if (this.fmcode == null || this.fmcode == undefined || this.fmcode == '') { alert("กรุณาเลือกชาวไร่"); }
    else if (cardid == null || cardid == undefined || cardid == '') { alert("กรุณากรอกเลขบัตรประชาชน"); }
    else if (birthday == undefined || birthday == '') { alert("กรุณาระบุวันเกิด"); }
    else {
      if (confirm('ยืนยันบันทึกใช้คนค้ำ' + this.fmcode)) {
        axios.post(url).then(res => {
          if (res.data.rowsAffected[0] == 1) {
            alert("บันทึกข้อมูลแล้วค่ะ");
            this.FormFirst.reset();
            this.FormCredit.reset();
            //this.Loadtendata();
            //this.goloadcheckpromiseall(); 
            this.goloadpromiseall();
            this.person1 = null;
            this.person2 = null;
            this.person3 = null;
          }
          else if (res.data.rowsAffected[0] == 0) {
            alert("บันทึกข้อมูลไม่สำเร็จ");
          }
          else { alert("บันทึกข้อมูลไม่สำเร็จ"); }
        }).catch(error => console.log(error))
      }
    }
  }

  ck2Str(value: null): boolean {
    let strVal: string = String(value).trim();
    if (value !== null && strVal.length > 3) return true;
    else return false;
  }

  // สืบค้นข้อมูลชาวไร่
  fmd_l: number;
  Findfarmmerdata() {
    let text = this.FormCredit.get('fmnameorcode').value;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/farmer_basicByfmcode?text_fm=${text}`
    let fmdata = url;
    axios.get(fmdata)
      .then(res => {
        let data = res.data.recordset;
        this.fmd_l = data.length;
        this.Farmerdata = new MatTableDataSource(data);
      }
      ).catch(error => {
        console.log(error);
      })
  }

  submitted = false;

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.Selectfarmer = null;
    this.allpromisebyzone = null;
    this.fullname = null;
    this.cardid = null;
    this.fmcode = null;
    this.fmbirthday = null;
    this.Farmerdata = null;
    // this.checkpromisebyzone = null;
    this.date_add = null;
  }

  choosedata: any[] = [];
  InOrRe_list(type: number, data: any) {
    //console.log(type, data);
    if (type == 0) {// ลบข้อมูล
      this.choosedata = this.choosedata.filter(el => el.fmcode != data.fmcode);
    }
    else if (type == 1) {// เพิ่มรายการ
      this.choosedata.push(data);
      this.choosedata = this.choosedata.filter((v, i, a) => a.findIndex(t => (t.fmcode == v.fmcode)) == i);
    }
    this.choosedata.sort((a, b) => new Date(b.dateupdate).getTime() - new Date(a.dateupdate).getTime());
    localStorage.setItem('fmcodedataforcredit', JSON.stringify(this.choosedata).toString());
  }

  cctest() {
    this.choosedata = [];
    $('input[type=checkbox]').prop('checked', false);
  }

  // สั่งพิมพ์เอกสาร
  printfontdoc() {
    this.router.navigateByUrl("/docforcredit", { state: { fmcode: this.choosedata } });
  }


  /*// (change)="onFileUpload($event.target.files)
  onFileUpload(files: FileList): void {
    console.log(files);
    const file = files[0]; // get single file
    const path = `brr_smartfarm/contract/photo/${this.supcode}/${file.name}`;
    const ref = this.storage.ref(path);
    const task = this.storage.upload(path, file);
    this.uploadPercentage$ = this.storage
      .upload(path, file)
      .percentageChanges();
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          ref
            .getDownloadURL()
            .toPromise()
            .then((url) => {
              // const photo: Photo = { url };
              // console.log(url);
              // this.urlimg = = url;
  
              // this.firestore.collection('photos').doc(this.truckq).set(photo);
            });
        })
      )
      .subscribe();
  
      let bucket = 'brr-farmluck.appspot.com'
      let url_pubilc = 'https://storage.googleapis.com/'+ bucket +'/brr_smartfarm/contract/photo/'+ this.supcode +'/'+ file.name;
      console.log(url_pubilc);
    }*/

  files_raw: FileList
  geturlcontact: any;
  // upload fire ภาพ
  onFileUpload(files: FileList): void {
    console.log(files);
    let d = new Date().getTime()
    console.log(d, 'getTime');
    const file = files[0]; // get single file
    //  const path = `brr_smartfarm/farmers/${this.fmcode}/${this.year}/promises/${file.name}`;
    const path = `brr_smartfarm/farmers/${this.year}/promises/${this.fmcode}_${d}.pdf`;
    const ref = this.storage.ref(path);
    const task = this.storage.upload(path, file);
    this.uploadPercentage$ = this.storage
      .upload(path, file)
      .percentageChanges();
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          ref
            .getDownloadURL()
            .toPromise()
            .then((url) => {
            });
        })
      )
      .subscribe();

    let bucket = 'brr-farmluck.appspot.com'
    let url_pubilc = 'https://storage.googleapis.com/' + bucket + '/brr_smartfarm/farmers/' + this.year + '/promises/' + this.fmcode + '_' + d + '.pdf';
    console.log(url_pubilc);
    this.geturlcontact = url_pubilc;
  }
  THtoLocalstring(thisdate: string) {
    if (!thisdate) { return ''; }
    const date1 = new Date(thisdate);
    let options: any = {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: 'UTC',
    };
    return date1.toLocaleString('th-TH', options);
  }

  // clear ช่อง
  cleartext() {
    $("input:text").val("");
    this.geturlcontact = '';
  }

}



